// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"da3327a5","654":"0d2700dd"}[chunkId] + ".css";
};